import React from 'react';

import TextBlock from './components/TextBlocks';
import NotesBlock from './components/NotesBlock';
import SpacerBlock from './components/SpacerBlock';
import TippingBlock from './components/TippingBlock';
import TopBarBlock from './components/TopBarBlock';
import BackButtonBlock from './components/BackButtonBlock';
import VisualAssetBlock from './components/VisualAssetBlock';
import FinixTippingBlock from './components/PublicFinixTippingBlock';
import FeedbackFormBlock from './components/FeedbackFormBlock';
import ProofOfServiceMediaBlock from './components/ProofOfServiceMediaBlock';
import VideoPlayerBlock from './components/VideoPlayerBlock';
import { CsatFormBlock, NpsFormBlock } from './components/RatingBlocks';
import { ActionButtonBlock, ReferralSelectionBlock, ReviewSelectionBlock } from './components/SelectionBlocks';
import type { FlowComponentConfig, FlowComponentRenderProps, FlowComponentType } from './types';

export type FlowComponentRegistry = {
  [K in FlowComponentType]: React.FC<FlowComponentRenderProps<Extract<FlowComponentConfig, { type: K }>>>;
};

export const flowComponentRegistry: FlowComponentRegistry = {
  actionButton: ActionButtonBlock,
  backButton: BackButtonBlock,
  csatForm: CsatFormBlock,
  feedbackForm: FeedbackFormBlock,
  finixTipping: FinixTippingBlock,
  h1: TextBlock,
  h2: TextBlock,
  h3: TextBlock,
  h4: TextBlock,
  notes: NotesBlock,
  npsForm: NpsFormBlock,
  proofOfServiceMedia: ProofOfServiceMediaBlock,
  referralSelection: ReferralSelectionBlock,
  reviewSelection: ReviewSelectionBlock,
  spacer: SpacerBlock,
  subheader: TextBlock,
  topBar: TopBarBlock,
  tipping: TippingBlock,
  videoPlayer: VideoPlayerBlock,
  visualAsset: VisualAssetBlock,
};
